import { useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { type DepositBonusCode, setBonusCode } from '@/api/auth';
import { removeUrlParameters } from '@/helpers/common';
import { useGetCommonStore } from '@/store';
import { REASON_FOR_UPDATING_USER } from '@/store/commonStore/slices/auth/helpers';

const BONUS_CODE_PARAM = 'bonus_code';

export function useBonusCode() {
  const useCommonStore = useGetCommonStore();

  const { isAuthenticated, pendingUser, fetchUser } = useCommonStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      pendingUser: state.pendingUser,
      fetchUser: state.fetchUser,
    }))
  );
  const searchParams = useSearchParams();
  const bonusCodeParam = searchParams.get(BONUS_CODE_PARAM);

  const [isCodeSet, setIsCodeSet] = useState(false);

  const handleSetBonusCode = useCallback(
    async (values: DepositBonusCode) => {
      removeUrlParameters([BONUS_CODE_PARAM]);
      setIsCodeSet(true);

      const { error } = await setBonusCode(values);

      if (!error) {
        fetchUser(REASON_FOR_UPDATING_USER.DEPOSIT);
      }
    },
    [fetchUser]
  );

  useEffect(() => {
    if (isCodeSet || !bonusCodeParam || pendingUser || !isAuthenticated) return;

    handleSetBonusCode({ depositBonusCode: bonusCodeParam });
  }, [
    isAuthenticated,
    pendingUser,
    bonusCodeParam,
    handleSetBonusCode,
    isCodeSet,
  ]);
}
